var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoodLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 62,
    viewBox: "0 0 50 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.73 55.31C44.31 61.09 37.4 62.73 31.91 59.99L6.39 46.68C0.139998 43.34 -1.51 36.28 1.38 30.66C3.65 26.83 7.43 24.68 11.47 24.58L6.85 22.21C0.379998 18.8 -1.17 11.69 1.74 6.07C4.08 2.21 8.02 0 12.18 0C13.98 0 15.8 0.4 17.57 1.27L43.6 14.91C49.19 17.99 51.18 25.13 48.1 30.72C45.79 34.48 42.07 36.66 38.05 36.69L43.28 39.4C48.93 42.66 50.93 49.73 47.73 55.31ZM35.12 36.31C35.29 36.02 35.44 35.71 35.58 35.41C36.23 33.95 36.6 32.32 36.6 30.61C36.6 24.08 31.31 18.78 24.77 18.78C20.32 18.78 16.43 21.24 14.42 24.88C14.25 25.19 14.09 25.51 13.95 25.84C13.31 27.3 12.95 28.93 12.95 30.63C12.95 37.16 18.24 42.46 24.78 42.46C29.25 42.46 33.13 39.98 35.13 36.32L35.12 36.31Z",
    fill: "#7272F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoodLogo);
export default __webpack_public_path__ + "static/media/ZoodLogo.287b0c369c2f14e7117f235ee490be54.svg";
export { ForwardRef as ReactComponent };